import { TextField, type TextFieldProps } from "@mui/material";
import { useMultiRefs } from "@root/utils/hooks/useMultiRef";
import type { InputMask } from "imask";
import { useEffect } from "react";
import { type ReactMaskOpts, useIMask } from "react-imask";
import type { UnmaskValue } from "react-imask/esm/mixin";

export interface IBasicTextFieldMask {
  maskOptions: ReactMaskOpts;
  onAccept?: (value: UnmaskValue<ReactMaskOpts>, maskRef: InputMask<ReactMaskOpts>, e?: InputEvent) => void;
  onComplete?: (value: UnmaskValue<ReactMaskOpts>, maskRef: InputMask<ReactMaskOpts>, e?: InputEvent) => void;
}

type ITextFieldMask = Omit<TextFieldProps, "value" | "onFocus"> & IBasicTextFieldMask & { value: string };

export const TextFieldMask = ({ maskOptions, onAccept, onComplete, value, inputRef, ...props }: ITextFieldMask) => {
  const {
    ref,
    value: imaskValue,
    setValue,
  } = useIMask(maskOptions, {
    onAccept,
    onComplete,
  });
  const multiRefs = useMultiRefs(ref, inputRef);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Update when value changes
  useEffect(() => {
    if (value !== imaskValue) {
      setValue(value);
    }
  }, [value]);

  return <TextField {...props} value={imaskValue} inputRef={multiRefs} />;
};
